module.exports = __webpack_public_path__ + "build/img/smm.8bc8bd6d.png";